import { TFollowUserParams, TPostActionResponse } from '.'

export async function postFollowUser(payload: TFollowUserParams) {
  const data = await makeRequest<TPostActionResponse>(
    '/api/post-actions/follow-user',
    {
      method: 'POST',
      body: payload,
    },
  )
  return data
}
